// Los tipos de la pantalla Pagos recibidos del Portal Cobrador. Describen LA FILA QUE SE PINTA,
// no un DTO del silo: todavía no hay endpoint de pagos del cobrador.

/** Por dónde entró el pago (`canal` del mock). */
export type PaymentChannel = 'store' | 'oxxo' | 'app' | 'pcf-auto';

/** El compromiso que este pago cumple, cuando el pago venía de uno. */
export interface PaymentPromise {
    promiseId: string;
    amount: number;
    /** Día de calendario para el que se había comprometido (`YYYY-MM-DD`). */
    dueDay: string;
}

/** Una línea del historial de contacto del caso (bloque «Contexto» del detalle). */
export interface PaymentContactEntry {
    at: string;
    channel: string;
    outcome: string;
    note: string;
}

export interface CollectorPaymentRow {
    paymentId: string;
    creditId: string;
    customerId: string;
    customerName: string;
    /** Instante en que entró el pago, en ISO con el huso del piso de venta. */
    receivedAt: string;
    amount: number;
    channel: PaymentChannel;
    promise: PaymentPromise | null;
    /** Días de mora del crédito ANTES de aplicar el pago. */
    arrearsDaysBefore: number;
    arrearsDaysAfter: number;
    /** Cuánto de este pago se aplicó a cuota, en pesos. */
    appliedInstallment: number;
    contactHistory: PaymentContactEntry[];
}

/** Valor del combo Canal cuando no filtra por ninguno («Todos» del mock). */
export const ANY_CHANNEL = '';

export interface PaymentFilters {
    search: string;
    channel: PaymentChannel | typeof ANY_CHANNEL;
    fromDay: string;
    toDay: string;
    /** Pesos, no centavos: el mock teclea el monto tal cual se lee en la tabla. */
    amountMin: number | null;
    amountMax: number | null;
}

export function emptyPaymentFilters(): PaymentFilters {
    return {
        search: '',
        channel: ANY_CHANNEL,
        fromDay: '',
        toDay: '',
        amountMin: null,
        amountMax: null,
    };
}

export const PAYMENT_STAT_KEYS = ['all', 'today', 'yesterday', 'week', 'withPromise'] as const;

export type PaymentStatKey = (typeof PAYMENT_STAT_KEYS)[number];

export type PaymentStats = Record<PaymentStatKey, number>;

/** Los cinco números de la banda superior (`.kpi-row` del mock). */
export interface PaymentTotals {
    todayAmount: number;
    todayCount: number;
    weekAmount: number;
    weekCount: number;
    monthAmount: number;
    monthCount: number;
    /** Avance de la meta del mes, en porcentaje entero. */
    goalPercent: number;
    averageTicket: number;
}
